function viewTransitionHelper({ skipTransition = false, classNames = [], updateDOM, }) {
    // Early return for unsupported view transitions or when skipping
    if (skipTransition || !document.startViewTransition) {
        const updateCallbackDone = Promise.resolve(updateDOM());
        const ready = Promise.reject(new Error('View transitions unsupported'));
        // Suppress unhandled promise rejection warning
        ready.catch(() => { });
        return {
            ready,
            updateCallbackDone,
            finished: updateCallbackDone,
            skipTransition: () => { },
        };
    }
    // Add transition classes to document element
    document.documentElement.classList.add(...classNames);
    // Start the view transition
    const transition = document.startViewTransition(updateDOM);
    // Clean up classes when transition finishes
    transition.finished.finally(() => {
        document.documentElement.classList.remove(...classNames);
    });
    return transition;
}

export { viewTransitionHelper };
//# sourceMappingURL=viewTransitionHelper.js.map
